/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tier_Feature_Intelligence_NoneInputs */

const en_tier_feature_intelligence_none = /** @type {(inputs: Tier_Feature_Intelligence_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Standard Search`)
};

const es_tier_feature_intelligence_none = /** @type {(inputs: Tier_Feature_Intelligence_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Búsqueda estándar`)
};

const fr_tier_feature_intelligence_none = /** @type {(inputs: Tier_Feature_Intelligence_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recherche Standard`)
};

const de_tier_feature_intelligence_none = /** @type {(inputs: Tier_Feature_Intelligence_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Standard-Suche`)
};

const ja_tier_feature_intelligence_none = /** @type {(inputs: Tier_Feature_Intelligence_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`標準検索`)
};

const zh_tier_feature_intelligence_none = /** @type {(inputs: Tier_Feature_Intelligence_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`标准搜索`)
};

const ar_tier_feature_intelligence_none = /** @type {(inputs: Tier_Feature_Intelligence_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بحث قياسي`)
};

const id_tier_feature_intelligence_none = /** @type {(inputs: Tier_Feature_Intelligence_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pencarian Standar`)
};

const it_tier_feature_intelligence_none = /** @type {(inputs: Tier_Feature_Intelligence_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ricerca Standard`)
};

const ru_tier_feature_intelligence_none = /** @type {(inputs: Tier_Feature_Intelligence_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Стандартный поиск`)
};

const pt_tier_feature_intelligence_none = /** @type {(inputs: Tier_Feature_Intelligence_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesquisa Padrão`)
};

const ko_tier_feature_intelligence_none = /** @type {(inputs: Tier_Feature_Intelligence_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`표준 검색`)
};

/**
* | output |
* | --- |
* | "Standard Search" |
*
* @param {Tier_Feature_Intelligence_NoneInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const tier_feature_intelligence_none = /** @type {((inputs?: Tier_Feature_Intelligence_NoneInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tier_Feature_Intelligence_NoneInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tier_feature_intelligence_none(inputs)
	if (locale === "es") return es_tier_feature_intelligence_none(inputs)
	if (locale === "fr") return fr_tier_feature_intelligence_none(inputs)
	if (locale === "de") return de_tier_feature_intelligence_none(inputs)
	if (locale === "ja") return ja_tier_feature_intelligence_none(inputs)
	if (locale === "zh") return zh_tier_feature_intelligence_none(inputs)
	if (locale === "ar") return ar_tier_feature_intelligence_none(inputs)
	if (locale === "id") return id_tier_feature_intelligence_none(inputs)
	if (locale === "it") return it_tier_feature_intelligence_none(inputs)
	if (locale === "ru") return ru_tier_feature_intelligence_none(inputs)
	if (locale === "pt") return pt_tier_feature_intelligence_none(inputs)
	return ko_tier_feature_intelligence_none(inputs)
});